// @generated by protoc-gen-grpc-gateway-es v0.3.1 with parameter "target=ts,generate_name_parser=true"
// @generated from file ai/h2o/mlops/deployer/v2/deployment_service.proto (package ai.h2o.mlops.deployer.v2, syntax proto3)
/* eslint-disable */

import type { Deployment } from "./deployment_pb";
import type { BigIntString } from "../../../../../runtime";
import { RPC } from "../../../../../runtime";

/**
 * Request message for CreateDeployment
 *
 * @generated from message ai.h2o.mlops.deployer.v2.CreateDeploymentRequest
 */
export type CreateDeploymentRequest = {
/**
 * Required. The resource name of the workspace to create deployment in.
 * Format: `workspaces/{workspace}`
 *
 * @generated from field: string parent = 1;
 */
parent: string;
/**
 * Required. The Deployment resource to create.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.Deployment deployment = 2;
 */
deployment: Deployment;
}
;
/**
 * Response message for CreateDeployment
 *
 * @generated from message ai.h2o.mlops.deployer.v2.CreateDeploymentResponse
 */
export type CreateDeploymentResponse = {
/**
 * The created Deployment.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.Deployment deployment = 1;
 */
deployment?: Deployment;
}
;
/**
 * Request message for ListDeployments
 *
 * @generated from message ai.h2o.mlops.deployer.v2.ListDeploymentsRequest
 */
export type ListDeploymentsRequest = {
/**
 * Required. The resource name of the workspace to list Deployments from.
 * Format: `workspaces/{workspace}`
 * Passing dash `-` as a workspace will list deployments across all workspaces
 * that the user has access to.
 *
 * @generated from field: string parent = 1;
 */
parent: string;
/**
 * Maximum number of items server should return in the response. When set to 0
 * server will decide how many items to return.
 * Server can decide to return less items then specified.
 *
 * @generated from field: int32 page_size = 2;
 */
pageSize?: number;
/**
 * Use value returned in next_page_token to retrieve next page of results.
 *
 * @generated from field: string page_token = 3;
 */
pageToken?: string;
/**
 * When used, server will only return deployment that match the filter.
 * Attempts to generally implement AIP-160 (https://aip.dev/160)
 * specification.
 *
 * Supported fields:
 *   * display_name
 *   * description
 *   * create_time
 *   * update_time
 *   * creator
 *   * experiment_ids
 *
 * Examples:
 * display_name = 'Some display' OR create_time <= 2023-12-30T23:59:43Z
 * create_time >= timestamp('2023-12-30T23:59:43Z') AND create_time <= timestamp('2024-03-20T08:00:00Z')
 * NOT(display_name = 'Some display name' OR create_time <= timestamp('2023-12-30T23:59:43Z'))
 * experiment_ids:c07a4cf2-0733-4419-937d-fdd7b804788e
 *
 * @generated from field: string filter = 4;
 */
filter?: string;
/**
 * When used, server will return deployments ordered by the specified fields.
 * Attempts to implement AIP-132 (https://aip.dev/132#ordering).
 * Supported fields are the ones supported by filter.
 *
 * @generated from field: string order_by = 5;
 */
orderBy?: string;
}
;
/**
 * Response message for ListDeployments
 *
 * @generated from message ai.h2o.mlops.deployer.v2.ListDeploymentsResponse
 */
export type ListDeploymentsResponse = {
/**
 * Collection of deployments.
 *
 * @generated from field: repeated ai.h2o.mlops.deployer.v2.Deployment deployments = 1;
 */
deployments?: Deployment[];
/**
 * Used to retrieve the next page of results.
 * When unset, no further items are available (this response was the last page).
 *
 * @generated from field: string next_page_token = 2;
 */
nextPageToken?: string;
}
;
/**
 * Request message for CountDeployments
 *
 * @generated from message ai.h2o.mlops.deployer.v2.CountDeploymentsRequest
 */
export type CountDeploymentsRequest = {
/**
 * Required. The resource name of the workspace to count Deployments from.
 * Format: `workspaces/{workspace}`
 *
 * @generated from field: string parent = 1;
 */
parent: string;
/**
 * When used, server will only count deployments that match the filter.
 * Attempts to generally implement AIP-160 (https://aip.dev/160)
 * specification.
 *
 * Supported fields:
 *   * display_name
 *   * description
 *   * create_time
 *   * update_time
 *   * creator
 *   * experiment_ids
 *
 * Examples:
 * display_name = 'Some display' OR create_time <= 2023-12-30T23:59:43Z
 * create_time >= timestamp('2023-12-30T23:59:43Z') AND create_time <= timestamp('2024-03-20T08:00:00Z')
 * NOT(display_name = 'Some display name' OR create_time <= timestamp('2023-12-30T23:59:43Z'))
 * experiment_ids:c07a4cf2-0733-4419-937d-fdd7b804788e
 *
 * @generated from field: string filter = 2;
 */
filter?: string;
}
;
/**
 * Response message for CountDeployments
 *
 * @generated from message ai.h2o.mlops.deployer.v2.CountDeploymentsResponse
 */
export type CountDeploymentsResponse = {
/**
 * Number of deployments.
 *
 * @generated from field: int64 count = 1;
 */
count?: BigIntString;
}
;
/**
 * The request message for getting an deployment.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.GetDeploymentRequest
 */
export type GetDeploymentRequest = {
/**
 * The name of the deployment to get, in the form:
 * "workspaces/{workspace}/deployment/{deployment}"
 *
 * @generated from field: string name = 1;
 */
name: string;
}
;
/**
 * The response message for getting an deployment.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.GetDeploymentResponse
 */
export type GetDeploymentResponse = {
/**
 * The retrieved deployment.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.Deployment deployment = 1;
 */
deployment?: Deployment;
}
;
/**
 * The request message for updating a deployment.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.UpdateDeploymentRequest
 */
export type UpdateDeploymentRequest = {
/**
 * The deployment to update.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.Deployment deployment = 1;
 */
deployment: Deployment;
/**
 * The fields to update.  An empty value, or value of `*`, implies all
 * updatable fields should apply.
 *
 * The following fields are supported:
 * `display_name`
 * `description`
 * `deployment.kubernetes_resource_spec`
 * `deployment.kubernetes_config_shortcut`
 * `deployment.security`
 * `deployment.monitoring`
 * `deployment.environment_variables`
 * `deployment.cors`
 * `deployment.vpa_spec`
 * `deployment.pod_disruption_budget`
 * Allowed security updates are:
 * - no security -> plain_text/hash/token_auth
 * - plain_text -> hash
 * - hash -> plain_text
 * - old plain_text -> new plain_text
 * - old hash -> new hash
 * - plain_text -> token_auth
 * - hash -> token_auth
 * - token_auth -> plain_text
 * - token_auth -> hash
 * All other cases would be ignored and updated passphrase hash must not be blank.
 *
 * @generated from field: google.protobuf.FieldMask update_mask = 2;
 */
updateMask?: string;
}
;
/**
 * The response message for updating a deployment.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.UpdateDeploymentResponse
 */
export type UpdateDeploymentResponse = {
/**
 * The updated deployment.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.Deployment deployment = 1;
 */
deployment?: Deployment;
}
;
/**
 * Request message for DeleteDeployment
 *
 * @generated from message ai.h2o.mlops.deployer.v2.DeleteDeploymentRequest
 */
export type DeleteDeploymentRequest = {
/**
 * Required. Deployment resource name.
 * Format: workspaces/{workspace}/deployments/{deployment}
 *
 * @generated from field: string name = 1;
 */
name: string;
}
;
/**
 * Response message for DeleteDeployment
 *
 * @generated from message ai.h2o.mlops.deployer.v2.DeleteDeploymentResponse
 */
export type DeleteDeploymentResponse = {
}
;
/**
 * Request message for RetryDeployment
 *
 * @generated from message ai.h2o.mlops.deployer.v2.RetryDeploymentRequest
 */
export type RetryDeploymentRequest = {
/**
 * Required. Deployment resource name.
 * Format: workspaces/{workspace}/deployments/{deployment}
 *
 * @generated from field: string name = 1;
 */
name: string;
}
;
/**
 * Response message for RetryDeployment
 *
 * @generated from message ai.h2o.mlops.deployer.v2.RetryDeploymentResponse
 */
export type RetryDeploymentResponse = {
}
;
/**
 * Request message for UpdateRuntimeImage
 *
 * @generated from message ai.h2o.mlops.deployer.v2.UpgradeRuntimeImageRequest
 */
export type UpgradeRuntimeImageRequest = {
/**
 * Required. Deployment resource name.
 * Format: workspaces/{workspace}/deployments/{deployment}
 *
 * @generated from field: string name = 1;
 */
name: string;
/**
 * Required. List of runtime image updates to apply to specific deployment compositions.
 * Each target specifies an experiment_id and the new runtime_image to apply to that composition.
 * Must contain at least one element.
 *
 * @generated from field: repeated ai.h2o.mlops.deployer.v2.RuntimeImageTarget targets = 2;
 */
targets: RuntimeImageTarget[];
}
;
/**
 * Specifies a runtime image update for a specific deployment composition identified by experiment_id.
 * This allows targeting individual compositions within split, shadow, or single deployments.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.RuntimeImageTarget
 */
export type RuntimeImageTarget = {
/**
 * ID of the experiment linked to deployment composition.
 * Used to identify which deployment composition(s) to update. Matches against
 * DeploymentComposition.experiment_id in single, shadow (primary/secondary),
 * or split elements.
 *
 * @generated from field: string experiment_id = 2;
 */
experimentId: string;
}
;
/**
 * Response message for UpdateRuntimeImage
 *
 * @generated from message ai.h2o.mlops.deployer.v2.UpgradeRuntimeImageResponse
 */
export type UpgradeRuntimeImageResponse = {
/**
 * The updated deployment.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.Deployment deployment = 1;
 */
deployment?: Deployment;
}
;
/**
 * Request message for PauseDeployment
 *
 * @generated from message ai.h2o.mlops.deployer.v2.PauseDeploymentRequest
 */
export type PauseDeploymentRequest = {
/**
 * Required. Deployment resource name.
 * Format: workspaces/{workspace}/deployments/{deployment}
 *
 * @generated from field: string name = 1;
 */
name: string;
}
;
/**
 * Response message for PauseDeployment
 *
 * @generated from message ai.h2o.mlops.deployer.v2.PauseDeploymentResponse
 */
export type PauseDeploymentResponse = {
}
;
/**
 * Request message for ResumeDeployment
 *
 * @generated from message ai.h2o.mlops.deployer.v2.ResumeDeploymentRequest
 */
export type ResumeDeploymentRequest = {
/**
 * Required. Deployment resource name.
 * Format: workspaces/{workspace}/deployments/{deployment}
 *
 * @generated from field: string name = 1;
 */
name: string;
}
;
/**
 * Response message for ResumeDeployment
 *
 * @generated from message ai.h2o.mlops.deployer.v2.ResumeDeploymentResponse
 */
export type ResumeDeploymentResponse = {
}
;
/**
 * Request message for DeleteDeploymentMonitoring
 *
 * @generated from message ai.h2o.mlops.deployer.v2.DeleteDeploymentMonitoringRequest
 */
export type DeleteDeploymentMonitoringRequest = {
/**
 * Required. Deployment resource name.
 * Format: workspaces/{workspace}/deployments/{deployment}
 *
 * @generated from field: string name = 1;
 */
name: string;
}
;
/**
 * Response message for DeleteDeploymentMonitoring
 *
 * @generated from message ai.h2o.mlops.deployer.v2.DeleteDeploymentMonitoringResponse
 */
export type DeleteDeploymentMonitoringResponse = {
}
;
/**
 * Creates a deployment.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.DeploymentService.CreateDeployment
 */
export const DeploymentService_CreateDeployment = new RPC<CreateDeploymentRequest,CreateDeploymentResponse>("POST", "/v2/{parent=workspaces/*}/deployments", "deployment");
/**
 * Returns a collection of Deployments within a workspace.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.DeploymentService.ListDeployments
 */
export const DeploymentService_ListDeployments = new RPC<ListDeploymentsRequest,ListDeploymentsResponse>("GET", "/v2/{parent=workspaces/*}/deployments");
/**
 * Returns the number of Deployments within a workspace.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.DeploymentService.CountDeployments
 */
export const DeploymentService_CountDeployments = new RPC<CountDeploymentsRequest,CountDeploymentsResponse>("GET", "/v2/{parent=workspaces/*}/deployments:count");
/**
 * Retrieves a single deployment.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.DeploymentService.GetDeployment
 */
export const DeploymentService_GetDeployment = new RPC<GetDeploymentRequest,GetDeploymentResponse>("GET", "/v2/{name=workspaces/*/deployments/*}");
/**
 * Updates a deployment.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.DeploymentService.UpdateDeployment
 */
export const DeploymentService_UpdateDeployment = new RPC<UpdateDeploymentRequest,UpdateDeploymentResponse>("PATCH", "/v2/{deployment.name=workspaces/*/deployments/*}", "deployment");
/**
 * Deletes a deployment.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.DeploymentService.DeleteDeployment
 */
export const DeploymentService_DeleteDeployment = new RPC<DeleteDeploymentRequest,DeleteDeploymentResponse>("DELETE", "/v2/{name=workspaces/*/deployments/*}");
/**
 * Retry failed deployment.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.DeploymentService.RetryDeployment
 */
export const DeploymentService_RetryDeployment = new RPC<RetryDeploymentRequest,RetryDeploymentResponse>("POST", "/v2/{name=workspaces/*/deployments/*}:retry");
/**
 * Update runtime image used in deployment
 * Caller requires 'actions/mlops/deployments/UPGRADE_RUNTIME_IMAGE' permission.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.DeploymentService.UpgradeRuntimeImage
 */
export const DeploymentService_UpgradeRuntimeImage = new RPC<UpgradeRuntimeImageRequest,UpgradeRuntimeImageResponse>("POST", "/v2/{name=workspaces/*/deployments/*}:upgradeRuntimeImage");
/**
 * Pause a deployment by scaling it to 0 replicas.
 * Caller requires 'actions/mlops/deployments/PAUSE' permission.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.DeploymentService.PauseDeployment
 */
export const DeploymentService_PauseDeployment = new RPC<PauseDeploymentRequest,PauseDeploymentResponse>("POST", "/v2/{name=workspaces/*/deployments/*}:pause");
/**
 * Resume a paused deployment by restoring its original replicas.
 * Caller requires 'actions/mlops/deployments/RESUME' permission.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.DeploymentService.ResumeDeployment
 */
export const DeploymentService_ResumeDeployment = new RPC<ResumeDeploymentRequest,ResumeDeploymentResponse>("POST", "/v2/{name=workspaces/*/deployments/*}:resume");
/**
 * Delete monitoring data related to deployment
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.DeploymentService.DeleteDeploymentMonitoring
 */
export const DeploymentService_DeleteDeploymentMonitoring = new RPC<DeleteDeploymentMonitoringRequest,DeleteDeploymentMonitoringResponse>("DELETE", "/v2/{name=workspaces/*/deployments/*}:deleteDeploymentMonitoring");
